import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';

async function doGetRentVerifications(hash) {
  const body = {
    data: {
      hash
    }
  }
  return await SuperFetch.post(apiUrls.getLandlordRentVerificationsBulk, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
function* getRentVerifications({ payload }) {
  const response = yield call(doGetRentVerifications, payload);
  if (response) {
    yield put(actions.doGetRentVerificationsSuccess(response));
  } else {
    yield put(actions.doGetRentVerificationsFailed(response));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_GET_RENT_VERIFICATIONS, getRentVerifications),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/outstandingRentVerifications/sagas.js